/* eslint-disable */
import React, { Component } from 'react'; 
import * as wording from '../js/wording.js';

import * as api from '../js/api.js';

import * as util from '../js/util.js';
import  './FormPage.scss'
import Button from '../UiComponent/Button';
import HTMLText from '../UiComponent/HTMLText';

import InputField from '../UiComponent/InputField';
import DropDownList from '../UiComponent/DropDownList';
class eCertPage extends Component {
	constructor(props) {
		super(props);	
		this.state = {		
			eMsg:{},
			dobYear:'',
			dobMonth:'',
			dobDay:'',
			bib:'',
			event:'',
			eventList:[],
			ready:false,
			apiReady:false,
			showError:false,
			errorMsg:'',
			certEvent:[]
			
		};
		
		this.getRaceEventList = this.getRaceEventList.bind(this);
		this.showError = this.showError.bind(this);
		this.closeError = this.closeError.bind(this);
	}

	componentDidMount() {	
		this.getRaceEventList(function(data,_this){
			if (data != null || data.length>0){
				_this.setState({eventList:data.result,event:data.result[0].id});
			}
		})
		wording.getWording('/wording/eCertPage.json').then((wordingJson) => this.setState({eMsg : wordingJson,ready:true}));
		document.title="HKISA E-Certificate System";
		
	}
	showError(msg){
		this.setState({errorMsg:msg,showError:true});
	}

	closeError(){
		this.setState({errorMsg:'',showError:false});
	}
	componentWillUnmount() {
	}

	onSearchClicked(){
		if (this.state.event == null || this.state.event == ''){
			this.showError(this.state.eMsg.emptyRaceZh+"<br/>"+this.state.eMsg.emptyRaceEn);
			return;			
		}

		if (!util.validateDate(this.state.dobDay+ '-' + this.state.dobMonth + '-' + this.state.dobYear) ){
			this.showError(this.state.eMsg.incorrectDobZh+"<br/>"+this.state.eMsg.incorrectDobEn);
			return;			
		}

		if (this.state.bib == null || this.state.bib == ''){
			this.showError(this.state.eMsg.emptyBibZh+"<br/>"+this.state.eMsg.emptyBibEn);
			return;			
		}
		this.getRaceCertList(this.state.event,this.state.dobYear+ '-' + this.state.dobMonth + '-' + this.state.dobDay,this.state.bib,function(data,_this){
			if (data != null && data.length >0){
				_this.setState({certEvent:data});
			}else{
				_this.showError(_this.state.eMsg.unmatchZh+"<br/>"+_this.state.eMsg.unmatchEn);
			}

		});
		
	
	}

	setEvent(value){
		this.setState({event:value});
	}


	getRaceEventList(callback){				
        var apiInfo ={
			api: window.info.config.filepathname+ '/php/api/getCertEventList.php',					
        };
        api.post(this, apiInfo,function(data, _this){			
			var returnJson = data || null;		
			callback(returnJson, _this);
			return;
		});        
	}

	getRaceCertList(id,dob,bib,callback){		
        var apiInfo ={
			api: window.info.config.filepathname+ '/php/api/getCertificateList.php?eventId='+id+'&bib='+bib+'&dob='+dob,					
        };
        api.post(this, apiInfo,function(data, _this){			
			var returnJson = data || null;		
			callback(returnJson, _this);
			return;
		});        
	}

	render() {		
		var certDesc='';
		var certItem='';
		if (this.state.certEvent && this.state.certEvent.length>0){
			certDesc = <HTMLText className='f2-font' text={this.state.eMsg.selectRace}/>;
			
			certItem = this.state.certEvent.map((cert) =>
				<div className='cert-section f2-font' key={cert.link} onClick={()=> window.open(window.info.config.filepathname+ '/php/api/getCertificate.php?r='+encodeURIComponent(cert.link),'_blank')}>{cert.name}</div>
			)
		}
		return (
            <div id="CertPage">
					{this.state.showError && (
					<React.Fragment>
						<div className='prompt-overlay'></div>
						<div className='error-prompt'>
							<div className='error-message'>
								<HTMLText text={this.state.errorMsg} className='f1-font'/>
							</div>
							<div className='popup-button-div'>
								<Button text={this.state.eMsg.closeZh +"<br/>" + this.state.eMsg.closeEn} 
								className='defaultButton popup-button' onClickAction={this.closeError}/>
							</div>
						</div>
					</React.Fragment>
					)}
				<div className='form-title'>
					<div className='form-title-image-overlay'></div>
					<HTMLText className='title-desc' text={this.state.eMsg.certTitleZh +"<br/>" + this.state.eMsg.certTitleEn}/>
				</div>
				<div className='ecert-content content'>
					<table className='cert-search-table'>
						<tbody>
						<tr className="row">
							<td>
								<HTMLText text={this.state.eMsg.eventZh +":<span class='ast'></span><br/>" + this.state.eMsg.eventEn +":<span class='ast'></span>"}/>
							</td>
							<td className=''>
								<DropDownList options={this.state.eventList} className='select'	parent={this} dataField='event' curValue={this.state.event}	/>
							</td>
						</tr>
						<tr className="row">
							<td>
								<HTMLText text={this.state.eMsg.dobZh +":<span class='ast'></span><br/>" + this.state.eMsg.dobEn +":<span class='ast'></span>"}/>
							</td>
							<td className='dob-td'>
								<InputField className='dob-input' dataField='dobYear' placeholder='YYYY' maxLength='4' parent={this} type='text' value={this.state.dobYear}/>
								<InputField className='dob-input' dataField='dobMonth' placeholder='MM' maxLength='2' parent={this} type='text' value={this.state.dobMonth}/>
								<InputField className='dob-input' dataField='dobDay' placeholder='DD' maxLength='2' parent={this} type='text' value={this.state.dobDay}/>
							</td>
						</tr>

						<tr className="row">
							<td>
								<HTMLText text={this.state.eMsg.bibZh +":<span class='ast'></span><br/>" + this.state.eMsg.bibEn +":<span class='ast'></span>"}/>
							</td>
							<td className='dob-td'>
								<InputField dataField='bib' maxLength='10' parent={this} type='text' value={this.state.bib}/>
								
							</td>
						</tr>
						<tr>
							<td>
								
							</td>
							<td><HTMLText text={this.state.eMsg.bibRemarkZh +"<br/>" + this.state.eMsg.bibRemarkEn}/></td>
						</tr>
						<tr className="row">
							<td>
								
							</td>
							<td>
								<Button	className='submitButton defaultButton' onClickAction={()=> this.onSearchClicked()} text={this.state.eMsg.search} />
							</td>
						</tr>
						</tbody>
					</table>
					<div className='line'></div>
					{certDesc}
					{certItem}
						
				</div>
		</div>
			
		);
	}
}

export default eCertPage;